import config from 'config/settings';

export default {
  SERVICES: [config.Channel.DIRECTORY, config.MessageClass.DIRECTORY_LISTING, 'services'],
  SCHEDULE: [config.Channel.SCHEDULER, config.MessageClass.SCHEDULE_LISTING, 'schedule']
};
